/** Shared Google Maps Places loader for checkout and account address forms */

const MAPS_API_KEY = 'AIzaSyARUX22fO86etfOvgUEl3IN-uAbZEY2UAs'
const MAPS_SCRIPT_ID = 'ihh-google-maps-script'
const MAPS_SCRIPT_URL = `https://maps.googleapis.com/maps/api/js?key=${MAPS_API_KEY}&libraries=places`

let loadPromise = null
let loadFailed = false

export function isGoogleMapsReady() {
	return typeof google !== 'undefined' && !!google?.maps?.places?.Autocomplete
}

function getMapsScriptElement() {
	return (
		document.getElementById(MAPS_SCRIPT_ID) ||
		document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]')
	)
}

function settleLoad(resolve, reject) {
	if (isGoogleMapsReady()) {
		loadFailed = false
		resolve()
		return
	}
	loadFailed = true
	loadPromise = null
	reject(new Error('Google Maps Places API failed to initialize'))
}

function waitOnScript(script, resolve, reject) {
	const finish = () => settleLoad(resolve, reject)

	if (script.dataset.loaded === 'true') {
		finish()
		return
	}

	script.addEventListener(
		'load',
		() => {
			script.dataset.loaded = 'true'
			finish()
		},
		{ once: true },
	)
	script.addEventListener(
		'error',
		() => {
			loadFailed = true
			loadPromise = null
			reject(new Error('Failed to load Google Maps script'))
		},
		{ once: true },
	)
}

/**
 * Load Maps JS API once; safe to call multiple times.
 * @returns {Promise<void>}
 */
export function loadGoogleMapsScript() {
	if (isGoogleMapsReady()) {
		return Promise.resolve()
	}

	if (loadFailed) {
		return Promise.reject(new Error('Google Maps Places API failed to initialize'))
	}

	if (loadPromise) {
		return loadPromise
	}

	const existingScript = getMapsScriptElement()
	if (existingScript) {
		if (!existingScript.id) {
			existingScript.id = MAPS_SCRIPT_ID
		}
		loadPromise = new Promise((resolve, reject) => {
			waitOnScript(existingScript, resolve, reject)
		})
		return loadPromise
	}

	loadPromise = new Promise((resolve, reject) => {
		const script = document.createElement('script')
		script.id = MAPS_SCRIPT_ID
		script.src = MAPS_SCRIPT_URL
		script.async = true
		script.onload = () => {
			script.dataset.loaded = 'true'
			settleLoad(resolve, reject)
		}
		script.onerror = () => {
			loadFailed = true
			loadPromise = null
			reject(new Error('Failed to load Google Maps script'))
		}
		document.head.appendChild(script)
	})

	return loadPromise
}
